var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Detail-page"},[(_vm.isMobile)?_c('mNewsDetail'):_c('NewsDetail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }